module.exports = __webpack_public_path__ + "images/skewness-11-desktop.png";